import { type AiTutorChatMessageDtoRole } from '@/api/gen/_model/aiTutorChatMessageDtoRole';
import { StaticRichTextRenderer } from '@/shared/features/rich-text';
import { cn } from '@/utils';
interface Props {
  role: AiTutorChatMessageDtoRole;
  content: string;
  className?: string;
}
export const Bubble = ({
  role,
  content,
  className
}: Props) => <div className={cn('rounded-md py-sm px-md text-body-lg-medium break-all whitespace-pre-line border border-opacity-assistive', 'mobile-lg:px-sm mobile-lg:py-xs mobile-lg:text-body-md-medium', {
  'bg-neutral': role === 'AI',
  'bg-violet-50': role === 'USER'
}, className)} data-sentry-component="Bubble" data-sentry-source-file="Bubble.tsx">
    <StaticRichTextRenderer as="div" text={content} data-sentry-element="StaticRichTextRenderer" data-sentry-source-file="Bubble.tsx" />
  </div>;